import * as d3 from "d3";

// Chart design based on the recommendations of Stephen Few. Implementation
// based on the work of Clint Ivy, Jamie Love, and Jason Davies.
// http://projects.instantcognition.com/protovis/bulletchart/
export function bullet() {
  var orient = "left"; // TODO top & bottom
  var reverse = false;
  var duration = 0;
  var ranges = bulletRanges;
  var markers = bulletMarkers;
  var errorOnValueFormula = hasErrorOnValueFormula;
  var ideals = bulletIdeals;
  var width = 380;
  var height = 30;
  var tickFormat = null;

  // For each small multiple…
  function bullet(g) {
    g.each(function (d, i) {
      var tempRanges = ranges.call(this, d, i);
      var rangez = [
        tempRanges.negMin1 === "Infinity"
          ? tempRanges.negMax1 * 1.2
          : tempRanges.negMin1,
        tempRanges.negMax1,
        tempRanges.interMin1,
        tempRanges.interMax1,
        tempRanges.posMin1,
        tempRanges.posMax1,
        tempRanges.interMin2,
        tempRanges.interMax2,
        tempRanges.negMin2,
        tempRanges.negMax2 === "Infinity"
          ? tempRanges.negMin2 * 1.2
          : tempRanges.negMax2,
      ];
      var rangezDescending = rangez.slice().sort(d3.descending);
      var rangezAscending = rangez.slice().sort(d3.ascending);
      var markerz = markers.call(this, d, i).slice().sort(d3.descending);
      var idealz = ideals.call(this, d, i).slice().sort(d3.descending);
      var min = Math.min(rangezAscending[0], markerz[0], idealz[0]);
      var max = Math.max(rangezDescending[0], markerz[0], idealz[0]);
      var g = d3.select(this);

      // Compute the new x-scale.
      var x1 = d3
        .scaleLinear()
        .domain([min, max])
        .range(reverse ? [width, 0] : [0, width]);
      // Retrieve the old x-scale, if this is an update.
      var x0 =
        this.__chart__ ||
        d3.scaleLinear().domain([0, Infinity]).range(x1.range());

      // Stash the new scale.
      this.__chart__ = x1;

      // Derive width-scales from the x-scales.
      var w0 = bulletWidth(x0, 0);

      if (isNaN(w0)) {
        w0 = 0;
      }

      var w1 = bulletWidth(x1, min);

      // Update the range rects.
      var range = g.selectAll("rect.range").data(rangezDescending);

      var redOnRightColorPalette = [
        "#e60246",
        "#e60246",
        "#ffbe00",
        "#ffbe00",
        "#009355",
        "#009355",
        "#ffbe00",
        "#ffbe00",
        "#e60246",
        "#e60246",
      ];
      var greenOnRightColorPalette = [
        "#009355",
        "#009355",
        "#ffbe00",
        "#ffbe00",
        "#e60246",
        "#e60246",
      ];
      var colorsToUse = redOnRightColorPalette;

      if (
        d.ideals.length === 1 &&
        shouldDisplayGreenColorOnRight(d.ideals[0], rangezDescending[0])
      ) {
        colorsToUse = greenOnRightColorPalette;
      }

      range
        .enter()
        .append("rect")
        .style("fill", function (d, i) {
          return colorsToUse[i];
        })
        .attr("width", w0)
        .attr("height", height)
        .attr("x", reverse ? x0 : 0)
        .transition()
        .duration(duration)
        .attr("width", w1)
        .attr("x", reverse ? x1 : 0);

      range
        .transition()
        .duration(duration)
        .attr("x", reverse ? x1 : 0)
        .attr("width", w1)
        .attr("height", height);

      // Update the marker lines.
      var marker = g.selectAll("line.marker").data(markerz);

      if (!errorOnValueFormula.call(this, d)) {
        marker
          .enter()
          .append("svg:image")
          .attr("class", "idealsvg")
          .attr("x", x0)
          .attr("y", -2)
          .attr("width", 30)
          .attr("height", 30)
          .attr("xlink:href", require("../assets/images/icon_indicator.svg"))
          .attr("transform", "translate(-15, 0)")
          .transition()
          .duration(duration)
          .attr("x", x1)
          .attr("y", -2)
          .attr("transform", "translate(-15, 0)");
      }

      marker
        .transition()
        .duration(duration)
        .attr("x", x1)
        .attr("y", -2)
        .attr("transform", "translate(-15, 0)");
      // Update the ideal lines.
      var ideal = g.selectAll("line.ideal").data(idealz);

      ideal
        .enter()
        .append("svg:image")
        .attr("class", "idealsvg")
        .attr("x", x0)
        .attr("y", -2)
        .attr("width", 30)
        .attr("height", 30)
        .attr("xlink:href", require("../assets/images/icon_ideal_value.svg"))
        .attr("transform", "translate(-15, 0)")
        .transition()
        .duration(duration)
        .attr("x", x1)
        .attr("y", -2)
        .attr("transform", "translate(-15, 0)");

      ideal
        .transition()
        .duration(duration)
        .attr("x", x1)
        .attr("y", -2)
        .attr("transform", "translate(-15, 0)");

      // Compute the tick format.
      var format = tickFormat || x1.tickFormat(8);

      // Update the tick groups.
      var tick = g.selectAll("g.tick").data(x1.ticks(8), function (d) {
        return this.textContent || format(d);
      });

      // Initialize the ticks with the old scale, x0.
      var tickEnter = tick
        .enter()
        .append("g")
        .attr("class", "tick")
        .attr("transform", bulletTranslate(x0))
        .style("opacity", 1e-6);

      tickEnter
        .append("line")
        .attr("y1", height)
        .attr("y2", (height * 7) / 6);

      tickEnter
        .append("text")
        .attr("text-anchor", "middle")
        .attr("dy", "1em")
        .attr("y", (height * 7) / 6)
        .style("font-family", "Oswald-Light")
        .style("font-size", "0.6rem")
        .text(format);

      // Transition the entering ticks to the new scale, x1.
      tickEnter
        .transition()
        .duration(duration)
        .attr("transform", bulletTranslate(x1))
        .style("opacity", 1);

      // Transition the updating ticks to the new scale, x1.
      var tickUpdate = tick
        .transition()
        .duration(duration)
        .attr("transform", bulletTranslate(x1))
        .style("opacity", 1);

      tickUpdate
        .select("line")
        .attr("y1", height)
        .attr("y2", (height * 7) / 6);

      tickUpdate
        .select("text")
        .attr("y", (height * 7) / 6)
        .style("font-family", "Oswald-Light")
        .style("font-size", "0.6rem");

      // Transition the exiting ticks to the new scale, x1.
      tick
        .exit()
        .transition()
        .duration(duration)
        .attr("transform", bulletTranslate(x1))
        .style("opacity", 1e-6)
        .remove();
    });
    d3.timerFlush();
  }

  // left, right, top, bottom
  bullet.orient = function (x) {
    if (!arguments.length) {
      return orient;
    }
    orient = x;
    reverse = orient === "right" || orient === "bottom";
    return bullet;
  };

  // ranges (bad, satisfactory, good)
  bullet.ranges = function (x) {
    if (!arguments.length) {
      return ranges;
    }
    ranges = x;
    return bullet;
  };

  // markers (previous, goal)
  bullet.markers = function (x) {
    if (!arguments.length) {
      return markers;
    }
    markers = x;
    return bullet;
  };

  // ideals (previous, goal)
  bullet.ideals = function (x) {
    if (!arguments.length) {
      return ideals;
    }

    ideals = x;
    return bullet;
  };

  bullet.width = function (x) {
    if (!arguments.length) {
      return width;
    }
    width = x;
    return bullet;
  };

  bullet.height = function (x) {
    if (!arguments.length) {
      return height;
    }
    height = x;
    return bullet;
  };

  bullet.tickFormat = function (x) {
    if (!arguments.length) {
      return tickFormat;
    }
    tickFormat = x;
    return bullet;
  };

  bullet.duration = function (x) {
    if (!arguments.length) {
      return duration;
    }
    duration = x;
    return bullet;
  };

  return bullet;
}

function bulletRanges(d) {
  return d.ranges;
}

function bulletMarkers(d) {
  // return d.markers
  return [d.value];
}

function bulletIdeals(d) {
  return d.ideals;
}

function bulletTranslate(x) {
  return function (d) {
    return "translate(" + x(d) + ",0)";
  };
}

function bulletWidth(x, min) {
  var x0 = x(min);
  return function (d) {
    return Math.abs(x(d) - x0);
  };
}

function hasErrorOnValueFormula(d) {
  if (d.errorOnValueFormula === "true") {
    return true;
  }
  return false;
}

function shouldDisplayGreenColorOnRight(idealValue, endOfPillar) {
  if (idealValue === endOfPillar) {
    return true;
  }

  return false;
}
